import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import PublicationPageV2 from '../../render_components/__template_components/publication_page_v2';
import UnknownTemplate from '../../render_components/__template_components/unknown_template';
import ContactsV1 from '../../render_components/__template_components/contacts_v1';
import Contacts from '../../render_components/__template_components/contacts';
import CartV1 from '../../render_components/__template_components/cart_v1';
import Cart from '../../render_components/__template_components/cart';
import ArticleBlank from '../../render_components/__template_components/article_blank';

export { renderPublication } from '../renderPublication';

const BlankTemplatePage = () => {
  const type = useSelector((state) => state.currentTab.type);
  const blankData = useSelector((state) => state.currentTab.blank_data);
  const blankTemplate = useSelector((state) => state.currentTab.blank_template);
  const currentTab = useSelector((state) => state.currentTab.currentTab);
  const [path_to_folder, setPath_to_folder] = React.useState(null);

  React.useEffect(() => {
    if (currentTab) {
      // Создаем path_to_folder
      const path_to_folder_value = 'https://' + currentTab.path + currentTab.blank_name + '/';
      setPath_to_folder(path_to_folder_value);
    }
  }, [currentTab]);

  const renderTemplate = () => {
    // console.log('BlankTemplatePage template_name (blank_template):', blankTemplate);
    switch (blankTemplate) {
      case 'Publication_1':
        return <PublicationPageV2 contentData={blankData} path_to_folder={path_to_folder} />;
      case 'publication_v2':
        return <PublicationPageV2 contentData={blankData} path_to_folder={path_to_folder} />;
      case 'article_blank':
        return <ArticleBlank contentData={blankData} path_to_folder={path_to_folder} />;
      case 'contacts_v1':
        const contactsV1Publication = {
          ...currentTab,
          content: currentTab.content || JSON.stringify(blankData),
          path: currentTab.path,
          eng_name: currentTab.eng_name || currentTab.blank_name,
        };
        return <ContactsV1 publication={contactsV1Publication} globalIndex={null} />;
      case 'contacts':
        const contactsPublication = {
          ...currentTab,
          content: currentTab.content || JSON.stringify(blankData),
          path: currentTab.path,
          eng_name: currentTab.eng_name || currentTab.blank_name,
        };
        return <Contacts publication={contactsPublication} globalIndex={null} />;
      case 'cart_v1':
        const cartV1Publication = {
          ...currentTab,
          content: currentTab.content || JSON.stringify(blankData),
          path: currentTab.path,
          eng_name: currentTab.eng_name || currentTab.blank_name,
        };
        return <CartV1 publication={cartV1Publication} globalIndex={null} />;
      case 'cart':
        const cartPublication = {
          ...currentTab,
          content: currentTab.content || JSON.stringify(blankData),
          path: currentTab.path,
          eng_name: currentTab.eng_name || currentTab.blank_name,
        };
        return <Cart publication={cartPublication} globalIndex={null} />;
      default:
        return (
          <UnknownTemplate
            contentData={blankData}
            path_to_folder={path_to_folder}
            templateName={blankTemplate}
            sectionType={type}
          />
        );
    }
  };

  return <div className={styles.blankTemplatePage}>{renderTemplate()}</div>;
};

export default BlankTemplatePage;
